enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
}

export default UserStatus;
